// @ts-nocheck
import { CartResult, GetCartsApiParameter } from "@insite/client-framework/Services/CartService";
import loadCarts from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCarts";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { SwapCartApiParameter, swapCartWithResult } from "@store/Framework/Services/CartService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export const getSavedCartsApiParameter: GetCartsApiParameter = {
    sort: "orderDate DESC",
    status: "Saved",
};

type SwapCartParameter = {
    swapCartApiParameter: SwapCartApiParameter;
};

type Parameter = HasOnError<string> & HasOnSuccess<string> & SwapCartParameter;

type HandlerType = ApiHandlerDiscreteParameter<Parameter, SwapCartApiParameter, CartResult>;

export const DispatchBeginSwapCart: HandlerType = props => {
    props.dispatch({
        type: "Context/BeginUpdatingCart",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.swapCartApiParameter;
};

export const SwapCart: HandlerType = async props => {
    const result = await swapCartWithResult(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.dispatch({
            type: "Context/CompleteUpdatingCart",
        });

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const LoadSavedCarts: HandlerType = props => {
    props.dispatch(
        loadCarts({
            apiParameter: {
                ...getSavedCartsApiParameter,
                additionalQueryStringParameters: {
                    cacheBuster: `${Date.now()}`,
                },
            },
        }),
    );
};

export const DispatchCompleteSwapingCart: HandlerType = props => {
    props.dispatch({
        type: "Context/CompleteUpdatingCart",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult.cart.id);
};

export const chain = [
    DispatchBeginSwapCart,
    PopulateApiParameter,
    SwapCart,
    LoadCart,
    LoadSavedCarts,
    DispatchCompleteSwapingCart,
    ExecuteOnSuccessCallback,
];

const swapCart = createHandlerChainRunner(chain, "SwapCart");
export default swapCart;
